import type {
  AuthUser,
  ChangePasswordDto,
  LoginRequest,
  LoginResponse,
  MeResponse,
  UpdateProfileDto,
} from '@s-blog/shared-types';
import { http } from './http';

export const authApi = {
  async login(payload: LoginRequest): Promise<AuthUser> {
    const { data } = await http.post<LoginResponse>('/auth/login', payload);
    return data.user;
  },
  async me(): Promise<AuthUser> {
    const { data } = await http.get<MeResponse>('/auth/me');
    return data.user;
  },
  async logout(): Promise<void> {
    await http.post('/auth/logout');
  },
  async refresh(): Promise<void> {
    await http.post('/auth/refresh');
  },
  async updateProfile(dto: UpdateProfileDto): Promise<AuthUser> {
    const { data } = await http.patch<MeResponse>('/auth/me', dto);
    return data.user;
  },
  async changePassword(dto: ChangePasswordDto): Promise<void> {
    await http.post('/auth/me/change-password', dto);
  },
};
